export const NAME = 'contactDetail';
export const CONTACT_NOT_FOUND_ERR_MSG = 'Contact not found by id';
